import request from './request';
import { resetToUTC } from '~~/common/js/universal/datetime';

const convertToDate = (obj) => {
  const props = ['time', 'sunrise', 'sunset'];
  props.forEach(
    (prop) => {
      if (obj[prop] !== undefined) {
        obj[prop] = resetToUTC(new Date(obj[prop]));
      }
    },
  );
  return obj;
};

export default async ({ units, place, region, language }) => {
  const response = await request({ units, place, region, language });
  const { current, forecast: rawForecast, location } = await response.json();

  if (!current || !location || !rawForecast || rawForecast.length === 0) {
    throw new Error('Weather: invalid data received from v2 API');
  }

  const initial = convertToDate(current);
  const forecast = rawForecast.map((entry) => {
    const converted = convertToDate(entry);
    converted.hourly.map((entryHourly) => convertToDate(entryHourly));
    return converted;
  });

  return { initial, location, forecast };
};
